import theme from "../theme";

interface SpinnerProps {
  width?: string;
  height?: string;
}

const SpinnerForMap: React.FC<SpinnerProps> = () => {
  // const { width, height } = props;

  return (
    <svg
      width="300px"
      height="300px"
      viewBox="0 0 100 100"
      preserveAspectRatio="xMidYMid"
    >
      <circle
        cx="50"
        cy="50"
        r="0"
        fill="none"
        stroke={theme.statusColor.MAIN}
        strokeWidth="2"
      >
        <animate
          attributeName="r"
          repeatCount="indefinite"
          dur="0.9615384615384615s"
          values="0;30"
          keyTimes="0;1"
          keySplines="0 0.2 0.8 1"
          calcMode="spline"
          begin="0s"
        ></animate>
        <animate
          attributeName="opacity"
          repeatCount="indefinite"
          dur="0.9615384615384615s"
          values="1;0"
          keyTimes="0;1"
          keySplines="0.2 0 0.8 1"
          calcMode="spline"
          begin="0s"
        ></animate>
      </circle>
      <circle
        cx="50"
        cy="50"
        r="0"
        fill="none"
        stroke="rgba(92, 200, 109, 0.787258064516129)"
        strokeWidth="2"
      >
        <animate
          attributeName="r"
          repeatCount="indefinite"
          dur="0.9615384615384615s"
          values="0;30"
          keyTimes="0;1"
          keySplines="0 0.2 0.8 1"
          calcMode="spline"
          begin="-0.4807692307692307s"
        ></animate>
        <animate
          attributeName="opacity"
          repeatCount="indefinite"
          dur="0.9615384615384615s"
          values="1;0"
          keyTimes="0;1"
          keySplines="0.2 0 0.8 1"
          calcMode="spline"
          begin="-0.4807692307692307s"
        ></animate>
      </circle>
    </svg>
  );
};

export default SpinnerForMap;
